import SalesforceIcon from '../../../../../assets/source/Salesforce.svg'
import LinkedInIcon from '../../../../../assets/source/LinkedIn.svg'
import GoogleSheets from '../../../../../assets/source/GoogleSheets.svg'
import JiraIcon from '../../../../../assets/source/Jira.svg'
import HubspotIcon from '../../../../../assets/source/Hubspot.svg'
import AirtableIcon from '../../../../../assets/source/Airtable.svg'
import OtherIcon from '../../../../../assets/source/Email.svg'
import SharetribeIcon from '../../../../../assets/source/Sharetribe.webp'
import DatabaseBlack from '../../../../../assets/source/DatabaseBlack.svg'
import PipedriveIcon from '../../../../../assets/source/PipedriveIcon.png'
import AttioIcon from '../../../../../assets/source/attio.webp'
import CopperIcon from '../../../../../assets/source/Copper.webp'
import GoogleAnalyticsIcon from '../../../../../assets/source/google-analytics.svg'
import GoogleAdsIcon from '../../../../../assets/source/google-ads.svg'
import AmplitudeIcon from '../../../../../assets/source/amplitude.svg'
import CloseIcon from '../../../../../assets/source/close.svg'
import ApolloIcon from '../../../../../assets/source/apollo.svg'
import MondayIcon from '../../../../../assets/source/Monday.webp'
import { useEffect, useState } from 'react'
import { Hubspot } from '../../../Appconnect/Hubspot/Hubspot'
import { LinkedIn } from '../../../Appconnect/LinkedIn/LinkedIn'
import { Sharetribe } from '../../../Appconnect/Sharetribe/Sharetribe'
import { Apollo } from '../../../Appconnect/Apollo/Apollo'

import { Salesforce } from '../../../Appconnect/GMail/Salesforce'
import { Other } from '../../../Appconnect/GMail/Other'
import { Database } from '../../../Appconnect/Database/Database'

import { SelectAPIorReport } from '../SelectAPIorReport/SelectAPIorReport'
import { APIConnector } from '../../../Appconnect/API/APIConnector'
import { useSelector } from 'react-redux'

// not yet active
import CrystalReportsIcon from '../../../../../assets/source/CrystalReports.png'
import GongIcon from '../../../../../assets/source/GongIcon.png'
import MarketoIcon from '../../../../../assets/source/MarketoIcon.png'
import MetaIcon from '../../../../../assets/source/MetaIcon.svg'
import MailerLiteIcon from '../../../../../assets/source/MailerLite.png'
import AsanaIcon from '../../../../../assets/source/asana.webp'
import IntercomIcon from '../../../../../assets/source/intercom.webp'
import ShopifyIcon from '../../../../../assets/source/shopify.webp'
import MailchimpIcon from '../../../../../assets/source/mailchimp.webp'
import CalendlyIcon from '../../../../../assets/source/calendly.webp'
import SquareIcon from '../../../../../assets/source/square.webp'
import MicrosoftDynamicsIcon from '../../../../../assets/source/MicrosoftDynamics.png'
import PowerBIIcon from '../../../../../assets/source/PowerBI.png'
import MicrosoftSSRSIcon from '../../../../../assets/source/MicrosoftSSRS.svg'
import MLSIcon from '../../../../../assets/source/MLS.png'
import NetsuiteIcon from '../../../../../assets/source/Netsuite.svg'
import OutreachIcon from '../../../../../assets/source/Outreach.png'
import OracleBIIcon from '../../../../../assets/source/OracleBI.svg'
import QuickbooksIcon from '../../../../../assets/source/Quickbooks.svg'
import WorkdayIcon from '../../../../../assets/source/Workday.png'
import SproutSocialIcon from '../../../../../assets/source/SproutSocial.png'
import TableauIcon from '../../../../../assets/source/Tableau.svg'
import TikTokIcon from '../../../../../assets/source/tiktok.png'
import YardiIcon from '../../../../../assets/source/Yardi.png'
import ZendeskIcon from '../../../../../assets/source/Zendesk.svg'
import { useWorkspaceMetadata } from '../../../../../api/hooks/workspaceMetadata/useWorkspaceMetadata'

export const sources = [
    {
        name: 'Salesforce',
        icon: SalesforceIcon,
        backgroundColor: '#E6F4FB',
        step: 3,
        sourceValue: 'Salesforce',
        disabled: false,
    },
    {
        name: 'Google Sheets',
        icon: GoogleSheets,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'GoogleSheets',
        disabled: false,
    },
    {
        name: 'HubSpot',
        icon: HubspotIcon,
        backgroundColor: '#FFF0EC',
        step: 3,
        sourceValue: 'HubSpot',
        disabled: false,
    },
    {
        name: 'Pipedrive',
        icon: PipedriveIcon,
        backgroundColor: '#E8F5EC',
        step: 3,
        sourceValue: 'Pipedrive',
        disabled: false,
    },
    {
        name: 'Attio',
        icon: AttioIcon,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'Attio',
        disabled: false,
    },
    {
        name: 'Copper',
        icon: CopperIcon,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'Copper',
        disabled: false,
    },
    {
        name: 'Close',
        icon: CloseIcon,
        backgroundColor: '#FFF0EC',
        step: 2,
        sourceValue: 'Close',
        disabled: false,
    },
    {
        name: 'Monday',
        icon: MondayIcon,
        backgroundColor: '#FFF0EC',
        step: 2,
        sourceValue: 'Monday',
        preferredSpelling: 'monday.com',
        disabled: false,
    },
    {
        name: 'LinkedIn',
        icon: LinkedInIcon,
        backgroundColor: '#FFF0EC',
        step: 2,
        sourceValue: 'LinkedIn',
        disabled: false,
    },
    {
        name: 'Airtable',
        icon: AirtableIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Airtable',
        disabled: false,
    },
    {
        name: 'Database',
        icon: DatabaseBlack,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Database',
        disabled: false,
    },
    {
        name: 'Google Analytics',
        icon: GoogleAnalyticsIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'GoogleAnalytics',
        disabled: false,
    },
    {
        name: 'Google Ads',
        icon: GoogleAdsIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'GoogleAds',
        disabled: false,
    },
    {
        name: 'Amplitude',
        icon: AmplitudeIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'Amplitude',
        disabled: false,
    },
    /*{
        name: 'Google Data Studio',
        icon: GoogleDataStudioIcon,
        backgroundColor: '#E8F1FE',
        step: 1,
        sourceValue: 'GoogleDataStudio',
        disabled: false,
    },*/
    {
        name: 'Apollo',
        icon: ApolloIcon,
        backgroundColor: '#E8F1FE',
        step: 3,
        sourceValue: 'Apollo',
        disabled: false,
    },
    {
        name: 'Quickbooks',
        icon: QuickbooksIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Quickbooks',
        preferredSpelling: 'QuickBooks',
        // for now, leave this as off, unless QB fights us hard on this (gj 11/25)
        allowSingleInstall: false,
        disabled: false,
    },
    {
        name: 'Sharetribe',
        icon: SharetribeIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'Sharetribe',
        disabled: false,
    },
    {
        name: 'Jira',
        icon: JiraIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Jira',
        disabled: false,
    },
    {
        name: 'TikTok',
        icon: TikTokIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'TikTok',
        disabled: false,
    },
    {
        name: 'MailerLite',
        icon: MailerLiteIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'MailerLite',
        disabled: false,
    },
    {
        name: 'Asana',
        icon: AsanaIcon,
        backgroundColor: '#FCE8E8',
        step: 2,
        sourceValue: 'Asana',
        disabled: false,
    },
    {
        name: 'Intercom',
        icon: IntercomIcon,
        backgroundColor: '#E8F4FD',
        step: 2,
        sourceValue: 'Intercom',
        disabled: false,
    },
    {
        name: 'Shopify',
        icon: ShopifyIcon,
        backgroundColor: '#F0F5E6',
        step: 2,
        sourceValue: 'Shopify',
        disabled: false,
    },
    {
        name: 'Calendly',
        icon: CalendlyIcon,
        backgroundColor: '#E6F0FF',
        step: 2,
        sourceValue: 'Calendly',
        disabled: false,
    },
    {
        name: 'Mailchimp',
        icon: MailchimpIcon,
        backgroundColor: '#FFF9E0',
        step: 2,
        sourceValue: 'Mailchimp',
        disabled: false,
    },
    {
        name: 'Square',
        icon: SquareIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Square',
        disabled: false,
    },
    {
        name: 'Other',
        icon: OtherIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Other',
        disabled: false,
    },
    {
        name: 'Crystal Reports',
        icon: CrystalReportsIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'CrystalReports',
        emailRedirect: true,
    },
    {
        name: 'Gong',
        icon: GongIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Gong',
        disabled: true,
    },
    {
        name: 'Marketo',
        icon: MarketoIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Marketo',
        disabled: true,
    },
    {
        name: 'Meta Ads',
        icon: MetaIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Meta',
        disabled: false,
    },
    {
        name: 'Microsoft Dynamics',
        icon: MicrosoftDynamicsIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'MicrosoftDynamics',
        disabled: true,
    },
    {
        name: 'Power BI',
        icon: PowerBIIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'PowerBI',
        disabled: true,
    },
    {
        name: 'Microsoft SSRS',
        icon: MicrosoftSSRSIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'MicrosoftSSRS',
        emailRedirect: true,
    },
    {
        name: 'MLS Realtor',
        icon: MLSIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'MLS',
        disabled: true,
    },
    {
        name: 'Netsuite',
        icon: NetsuiteIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Netsuite',
        disabled: true,
    },
    {
        name: 'Outreach',
        icon: OutreachIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Outreach',
        disabled: true,
    },
    {
        name: 'Oracle BI',
        icon: OracleBIIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'OracleBI',
        disabled: true,
    },
    {
        name: 'Workday',
        icon: WorkdayIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Workday',
        disabled: true,
    },
    {
        name: 'Sprout Social',
        icon: SproutSocialIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'SproutSocial',
        disabled: true,
    },
    {
        name: 'Tableau',
        icon: TableauIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Tableau',
        disabled: true,
    },
    {
        name: 'Yardi',
        icon: YardiIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Yardi',
        emailRedirect: true,
    },
    {
        name: 'Zendesk',
        icon: ZendeskIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Zendesk',
        disabled: true,
    },
]

export const ConnectDatasource = ({
    onClose,
    source,
    sourceStep,
    stepBack,
    goNext,
    workspaceMetadata,
}) => {
    const [type, setType] = useState('Transactional')
    const [step, setStep] = useState(sourceStep || 0)
    const [basicConfiguration, setBasicConfiguration] = useState(null)
    const [isAPI, setIsAPI] = useState(false)
    const [visibleSources, setVisibleSources] = useState([])
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    const token = useSelector((state) => state.auth.token)
    const { workspaceMetadata: metadata } = useWorkspaceMetadata(userID, workspaceID, token)

    // figure out which sources are already installed and disable them
    useEffect(() => {
        if (metadata && metadata.apiConnections) {
            const updatedSources = sources.map((source) => {
                // Check if this source is mentioned in the metadata as installed
                const isInstalled = metadata.apiConnections.some(
                    (connection) => connection.connectionType === source.sourceValue
                )
                return { ...source, isInstalled }
            })
            setVisibleSources(updatedSources)
        } else {
            setVisibleSources(sources) // Fallback to default if no metadata or not loaded
        }
    }, [metadata]) // Dependency on metadata to re-run when metadata updates

    useEffect(() => {
        if (step === 0 && visibleSources.length === 0) {
            setVisibleSources(sources)
        } else {
            setVisibleSources([])
        }
    }, [step])

    const renderSource = () => {
        switch (source) {
            case 'HubSpot':
                if (isAPI) {
                    return (
                        <APIConnector
                            selectedInbox={basicConfiguration}
                            setSelectedInbox={setBasicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={() => setStep(3)}
                            type={type}
                            connectorType="HubSpot"
                            disabled
                            goNext={goNext}
                        />
                    )
                } else {
                    return (
                        <Hubspot
                            basicConfiguration={basicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={() => setStep(3)}
                            type={type}
                        />
                    )
                }
            case 'LinkedIn':
                return (
                    <LinkedIn
                        basicConfiguration={basicConfiguration}
                        open={true}
                        onClose={onClose}
                        stepBack={stepBack}
                        type={type}
                    />
                )
            case 'Salesforce':
                if (isAPI) {
                    return (
                        <APIConnector
                            goNext={goNext}
                            selectedInbox={basicConfiguration}
                            setSelectedInbox={setBasicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={() => setStep(3)}
                            type={type}
                            connectorType="Salesforce"
                        />
                    )
                } else {
                    return (
                        <Salesforce
                            basicConfiguration={basicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={stepBack}
                            type={type}
                        />
                    )
                }
            case 'Database':
                return (
                    <Database
                        basicConfiguration={basicConfiguration}
                        open={true}
                        onClose={onClose}
                        stepBack={stepBack}
                        type={type}
                    />
                )
            case 'Sharetribe':
                return (
                    <Sharetribe
                        basicConfiguration={basicConfiguration}
                        open={true}
                        onClose={onClose}
                        stepBack={stepBack}
                        type={type}
                    />
                )
            case 'Pipedrive':
            case 'Airtable':
            case 'GoogleAnalytics':
            case 'GoogleAds':
            case 'Amplitude':
            case 'Jira':
            case 'Close':
            case 'Monday':
            case 'GoogleSheets':
            case 'Quickbooks':
            case 'Attio':
            case 'Copper':
            case 'TikTok':
            case 'MailerLite':
            case 'Meta':
            case 'Asana':
            case 'Intercom':
            case 'Shopify':
            case 'Calendly':
            case 'Mailchimp':
            case 'Square':
                return (
                    <APIConnector
                        goNext={goNext}
                        selectedInbox={basicConfiguration}
                        setSelectedInbox={setBasicConfiguration}
                        open={true}
                        onClose={onClose}
                        stepBack={stepBack}
                        type={type}
                        connectorType={source}
                    />
                )
            case 'Apollo':
                if (isAPI) {
                    return (
                        <APIConnector
                            goNext={goNext}
                            selectedInbox={basicConfiguration}
                            setSelectedInbox={setBasicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={() => setStep(3)}
                            type={type}
                            connectorType="Apollo"
                        />
                    )
                } else {
                    return (
                        <Apollo
                            selectedInbox={basicConfiguration}
                            open={true}
                            onClose={onClose}
                            stepBack={stepBack}
                            type={type}
                            connectorType="Apollo"
                        />
                    )
                }
            case 'Other':
                return (
                    <Other
                        basicConfiguration={basicConfiguration}
                        open={true}
                        onClose={onClose}
                        stepBack={stepBack}
                        type={type}
                    />
                )
        }
    }

    const renderStepContent = () => {
        switch (step) {
            case 2:
                return renderSource()
            case 3:
                return (
                    <SelectAPIorReport
                        index={3}
                        setType={setType}
                        setStep={setStep}
                        stepBack={stepBack}
                        onClose={onClose}
                        handleContinue={(active) => {
                            if (active === 'Report Data Source') {
                                setIsAPI(false)
                                setStep(2)
                            } else if (active === 'API Data Source') {
                                setIsAPI(true)
                                setStep(2)
                            }
                        }}
                        sourceName={source}
                    />
                )
        }
    }

    return <>{renderStepContent()}</>
}
